module.exports = __webpack_public_path__ + "img/energy_label.b8b54360.svg";